import React from 'react'
import { object } from 'prop-types'
import { connect } from 'react-redux'
import { StripeProvider, Elements } from 'react-stripe-elements'

import styles from './PlanSubscriptionPage.styl'
import { AsideThumbBanner, Loading } from '../../../website/components'
import { PaymentForm, SubscriptionSummary } from '../../components'
import Success from '../../components/Messages/Success'
import TranslationContext from '../../../utils/TranslationContext'


const plansDescriptions = {
	1: {
		en: '3 to 4 aerobic workouts per week, complete with workout and flexibility circuits.\nRecommended challenges: 10/15Km',
		pt: '3 a 4 treinos de base aeróbia por semana, complementados com trabalho de musculação e flexibilidade.\nDesafios aconselhados: 10/15Km'
	},
	2: {
		en: '5 to 6 aerobic workouts per week, complete with workout and flexibility circuits.\nRecommended challenges: 10/21Km',
		pt: '5 a 6 treinos de base aeróbia por semana, complementados com trabalho de musculação e flexibilidade.\nDesafios aconselhados: até 10/21Km'
	},
	3: {
		en: '7 aerobic-based daily/bi-daily workouts per week, complete with workout and flexibility circuits.\nRecommended challenges: 10/42Km',
		pt: '7 treinos diários/bi-diários de base aeróbia por semana, complementados com trabalho de musculação e flexibilidade.\nDesafios aconselhados: 10/42Km'
	}
}

class PlanSubscriptionPage extends React.Component {

	static fetchQueries = [
		'services/$id',
		'athletes/profile'
	]

	static propTypes = {
		service: object,
		athlete: object,
		match: object
	}

	constructor(props) {
		super(props)
		this.state = {
			selectedPlan: {},
			paymentInformation: {},
			step: 1,
			stripe: null,
			success: false
		}

		this.handleStepChange = this.handleStepChange.bind(this)
		this.scrollToElement = this.scrollToElement.bind(this)
	}

	componentDidMount() {
		// eslint-disable-next-line
		this.setState({ stripe: window.Stripe('pk_live_Hlp8ytHR6oaB1XWulwxcquTs') })
		// pk_test_0rqIrGX12DM5Zh1ZsZSKQDLS
		// pk_live_Hlp8ytHR6oaB1XWulwxcquTs
	}

	handleStepChange(step) {
		this.setState({ step })
		this.scrollToElement()
	}

	scrollToElement() {
		if (!window) { return }
		this.scrollElement = !this.scrollElement ? window.document.querySelector('#step') : null
		if (this.scrollElement) {
			this.scrollElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
			this.scrollElement = null
		}
	}
	handleSuccess() {
		this.setState({ success: true, step: 1 }, () => { setTimeout(() => { window.location = '/apt/profile/subscriptions' }, 1500) })
	}
	render() {
		const { service, athlete, match: { params: { locale } } } = this.props
		const { selectedPlan, step, paymentInformation, success, stripe } = this.state

		const activeSubscription = ((athlete || {}).subscriptions || []).find(subscription => subscription.status !== 'expired')
		if (!service || !athlete) { return <Loading /> }
		const plans = (service.plans || []).sort((a, b) => a.order - b.order).map((ele, index) => (
			<div key={ index } className={ `${ styles['plan-container'] } ${ selectedPlan.index === index ? styles['active-plan'] : '' }` }>
				{ success ? <Success /> : null }
				<div className={ styles['plan-card'] }>
					<div className={ styles['card-title'] }>
						<h1>{ ele.title }</h1>
						<p>{ plansDescriptions[(ele.order || 0)][locale || 'pt'] }</p>
					</div>
					<hr />
					<div className={ styles['card-price'] }>
						<h1>{ ele.price }€<span className={ styles['smaller-title'] }> / sem</span></h1>
						<p>{ ele.minWeekNumber } semanas</p>
					</div>
					<hr />
					<div className={ styles['choose-button'] } onClick={ () => { window.scroll(0, 0); this.setState({ selectedPlan: { index, plan: ele }, step: 3 }) } }>
						Escolher plano!
					</div>
				</div>
			</div>
		))
		return (
			<div id="step" className={ styles['section'] }>
				<div className={ `${ styles['step-counter'] } ${ styles[`progress-${ step }`] }` }>
					<div>
						<div />
					</div>
					<ul>
						<li className={ step === 1 ? styles['current'] : '' } onClick={ () => { this.handleStepChange(1) } }><span>1</span><small> Descrição do plano</small></li>
						<li className={ step === 2 ? styles['current'] : '' } onClick={ () => { this.handleStepChange(2) } }><span>2</span><small> Escolha do plano</small></li>
						<li className={ step === 3 ? styles['current'] : '' }><span>3</span><small> Pagamento</small></li>
						<li className={ step === 4 ? styles['current'] : '' }><span>4</span><small> Resumo</small></li>
					</ul>
				</div>
				<StripeProvider stripe={ stripe }>
					<Elements fonts={ [{ cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat' }] }>
						<div className={ styles['content'] }>
							<div className={ `${ styles['payment-form-container'] } ${ styles[`step-${ step }`] }` }>
								<div className={ styles['plan-description'] }>
									<AsideThumbBanner service={ service } changeStep={ () => { this.handleStepChange(2) } } renderButton={ !activeSubscription } />
								</div>
								<div className={ styles['plans-container'] }>
									<div>
										{ plans }
									</div>
								</div>
								<div>
									<PaymentForm
										athlete={ athlete }
										plan={ selectedPlan.plan }
										handleNext={ (data) => {
											this.scrollToElement()
											this.setState({ step: 4, paymentInformation: data })
										} }
									/>
								</div>
								<SubscriptionSummary plan={ selectedPlan.plan } paymentInformation={ paymentInformation } athlete={ athlete } handleSuccess={ this.handleSuccess.bind(this) } />
							</div>
						</div>
					</Elements>
				</StripeProvider>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	service: state.fetch.results[PlanSubscriptionPage.fetchQueries[0]],
	athlete: state.fetch.results[PlanSubscriptionPage.fetchQueries[1]]
})

export default connect(mapStateToProps)(PlanSubscriptionPage)



// WEBPACK FOOTER //
// ./src/client/webapp/pages/PlanSubscriptionPage/PlanSubscriptionPage.js